"use strict";

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = exports.useBreadcrumb = exports.BreadcrumbProvider = exports.BreadcrumbContext = void 0;

var antd_1 = require("antd");

var orderBy_1 = __importDefault(require("lodash/orderBy"));

var path_1 = __importDefault(require("path"));

var react_1 = __importStar(require("react"));

var react_router_dom_1 = require("react-router-dom");

exports.BreadcrumbContext = react_1.default.createContext({
  activeCrumbs: [],
  addCrumb: function addCrumb() {},
  removeCrumb: function removeCrumb() {}
});

function BreadcrumbProvider(_ref) {
  var children = _ref.children;

  var _ref2 = (0, react_1.useState)([]),
      _ref3 = _slicedToArray(_ref2, 2),
      activeCrumbs = _ref3[0],
      setActiveCrumbs = _ref3[1];

  var value = {
    activeCrumbs: activeCrumbs,
    addCrumb: function addCrumb(info) {
      setActiveCrumbs(function (crumbs) {
        return [].concat(_toConsumableArray(crumbs), [info]);
      });
    },
    removeCrumb: function removeCrumb(href) {
      setActiveCrumbs(function (crumbs) {
        return crumbs.filter(function (crumb) {
          return crumb.href !== href;
        });
      });
    }
  };
  return react_1.default.createElement(exports.BreadcrumbContext.Provider, {
    value: value,
    children: children
  });
}

exports.BreadcrumbProvider = BreadcrumbProvider;

function useBreadcrumb(info, key) {
  var href = (0, react_router_dom_1.useResolvedPath)('').pathname;

  var _ref4 = (0, react_1.useContext)(exports.BreadcrumbContext),
      addCrumb = _ref4.addCrumb,
      removeCrumb = _ref4.removeCrumb;

  (0, react_1.useEffect)(function () {
    if (Array.isArray(info)) {
      var resolvedItems = info.map(function (item) {
        return Object.assign(Object.assign({}, item), {
          href: item.href ? item.href : item.relativeHref ? path_1.default.resolve(href, item.relativeHref) : href
        });
      });

      var _iterator = _createForOfIteratorHelper(resolvedItems),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          addCrumb(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return function () {
        var _iterator2 = _createForOfIteratorHelper(resolvedItems),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            removeCrumb(item.href);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };
    } else {
      addCrumb(Object.assign(Object.assign({}, info), {
        href: href
      }));
      return function () {
        removeCrumb(href);
      };
    }
  }, [key]);
}

exports.useBreadcrumb = useBreadcrumb;

function Breadcrumbs() {
  var _ref5 = (0, react_1.useContext)(exports.BreadcrumbContext),
      activeCrumbs = _ref5.activeCrumbs;

  var sorted = (0, orderBy_1.default)(activeCrumbs, function (crumb) {
    return crumb.href.length;
  });
  return react_1.default.createElement(antd_1.Breadcrumb, null, sorted.map(function (crumb) {
    return react_1.default.createElement(antd_1.Breadcrumb.Item, {
      key: crumb.href
    }, react_1.default.createElement(react_router_dom_1.Link, {
      to: crumb.href
    }, crumb.title));
  }));
}

exports.Breadcrumbs = Breadcrumbs;